// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"879": "9bf85c83ae9a9fbf","889": "dbe9ffd6c5647d96",}[chunkId] + ".js"
}